export default {
  orderNow: "Commander maintenant",
  exploreNow: "Explorer maintenant",
}
